var _linearGradient, _ellipse, _path, _path2, _polygon, _polygon2, _polygon3, _linearGradient2, _ellipse2, _path3, _path4, _polygon4, _polygon5, _polygon6, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNftToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 850 850",
    viewBox: "0 0 850 850",
    id: "NFTtoken",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 472.981,
    x2: 617.683,
    y1: 264.668,
    y2: 264.668,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68eef9",
    className: "stopColorf9dd68 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ebf9",
    className: "stopColorf9a942 svgShape"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 545.33,
    cy: 264.67,
    fill: "url(#a)",
    rx: 72.33,
    ry: 73.47
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M545.3,330.35c-9.09,0-18.15-1.97-26.67-5.89c-32.47-14.94-46.92-53.91-32.21-86.88 c7.18-16.09,20.12-28.34,36.43-34.48c16.09-6.05,33.55-5.43,49.18,1.76c32.47,14.94,46.92,53.91,32.21,86.88 c-7.18,16.09-20.12,28.34-36.43,34.48C560.49,328.98,552.89,330.35,545.3,330.35z M545.36,203.74c-7.02,0-14.06,1.27-20.83,3.82 c-15.12,5.69-27.11,17.04-33.77,31.97c-13.65,30.6-0.25,66.77,29.86,80.62c14.47,6.66,30.64,7.24,45.52,1.63 c15.12-5.69,27.11-17.04,33.77-31.97c13.65-30.6,0.25-66.77-29.86-80.62C562.16,205.56,553.77,203.74,545.36,203.74z",
    className: "colorffffff svgShape"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M506.82,269.35l4.07,1.87l16.58-37.18l-4.07-1.87l6.04-13.55l37.34,17.18 c6.78,3.12,11.44,6.96,13.98,11.51c2.54,4.56,2.65,9.45,0.31,14.68c-1.45,3.25-3.43,5.64-5.94,7.17 c-2.51,1.53-5.04,2.39-7.58,2.59c-2.54,0.19-4.84,0.05-6.91-0.44l-0.37,0.83c3.68,2.16,6.6,4.99,8.75,8.51 c2.16,3.52,2.03,7.97-0.38,13.37c-2.58,5.78-6.61,9.03-12.08,9.73c-5.48,0.7-11.63-0.52-18.46-3.67l-37.34-17.18L506.82,269.35 z M548.6,260.1c1.57,0.72,2.94,0.84,4.11,0.35c1.17-0.49,2.16-1.65,2.97-3.46L557,254c0.81-1.82,1.01-3.33,0.61-4.55 c-0.41-1.21-1.4-2.18-2.97-2.91l-4.39-2.02l-6.04,13.55L548.6,260.1z M538.63,283.99c1.57,0.72,2.94,0.84,4.11,0.35 c1.17-0.49,2.16-1.65,2.97-3.47l1.62-3.63c0.81-1.82,1.01-3.33,0.61-4.55c-0.41-1.21-1.4-2.19-2.97-2.91l-4.96-2.28 l-6.34,14.21L538.63,283.99z",
    className: "colorffffff svgShape"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "524.62 301.97 517.66 298.77 552.33 221.05 559.29 224.25",
    className: "colorffffff svgShape"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "559.82 243.37 555.72 241.48 562.7 225.82 566.8 227.71",
    className: "colorffffff svgShape"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "532.13 305.43 528.03 303.54 535.02 287.88 539.12 289.77",
    className: "colorffffff svgShape"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 375.363,
    x2: 520.059,
    y1: 271.284,
    y2: 271.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68eef9",
    className: "stopColorf9dd68 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ebf9",
    className: "stopColorf9a942 svgShape"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 447.71,
    cy: 271.28,
    fill: "url(#b)",
    rx: 72.33,
    ry: 73.47
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M447.78,336.97c-6.53,0-13.1-1.02-19.51-3.07c-16.58-5.31-30.1-16.87-38.06-32.56 c-16.32-32.17-3.81-71.83,27.87-88.41c15.26-7.99,32.69-9.5,49.07-4.26c16.58,5.31,30.1,16.87,38.06,32.56l0,0 c16.31,32.17,3.81,71.83-27.87,88.41C468.05,334.5,457.95,336.97,447.78,336.97z M447.65,210.36c-9.42,0-18.76,2.28-27.37,6.78 c-29.39,15.38-40.98,52.19-25.83,82.05c7.38,14.55,19.9,25.27,35.27,30.19c15.16,4.85,31.29,3.45,45.42-3.94 c29.39-15.38,40.98-52.19,25.83-82.05l0,0c-7.38-14.55-19.91-25.27-35.27-30.19C459.77,211.3,453.7,210.36,447.65,210.36z",
    className: "colorffffff svgShape"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M427.42,304.86l3.97-2.08l-18.4-36.29l-3.97,2.08l-6.71-13.23l36.44-19.07 c6.62-3.46,12.47-4.79,17.57-3.99c5.09,0.8,8.94,3.76,11.53,8.87c1.61,3.17,2.22,6.24,1.85,9.19c-0.38,2.95-1.28,5.5-2.71,7.64 c-1.43,2.14-2.97,3.88-4.63,5.23l0.41,0.81c3.95-1.59,7.95-2.15,12-1.69c4.05,0.47,7.42,3.33,10.09,8.6 c2.86,5.65,2.86,10.87,0.01,15.66c-2.86,4.8-7.62,8.94-14.29,12.43l-36.44,19.07L427.42,304.86z M446.21,265.85 c1.53-0.8,2.48-1.82,2.82-3.06c0.35-1.23,0.07-2.74-0.83-4.51l-1.47-2.9c-0.9-1.77-1.95-2.88-3.14-3.31 c-1.19-0.43-2.55-0.24-4.09,0.56l-4.29,2.24l6.71,13.22L446.21,265.85z M458.46,288.62c1.53-0.8,2.47-1.82,2.82-3.06 c0.34-1.23,0.07-2.74-0.83-4.51l-1.8-3.55c-0.9-1.77-1.95-2.88-3.13-3.31c-1.19-0.43-2.55-0.25-4.09,0.56l-4.84,2.53 l7.04,13.87L458.46,288.62z",
    className: "colorffffff svgShape"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "463.65 310.93 456.86 314.49 418.39 238.64 425.18 235.08",
    className: "colorffffff svgShape"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "440.26 246.53 436.26 248.62 428.51 233.34 432.51 231.25",
    className: "colorffffff svgShape"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "470.98 307.1 466.98 309.19 459.23 293.91 463.23 291.81",
    className: "colorffffff svgShape"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.11,
    height: 37.2,
    x: 241.83,
    y: 222.41,
    fill: "#d7ecee",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7ecee",
    points: "229.06 226.07 253.39 201.74 277.72 226.07",
    className: "colord7deee svgShape"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.48,
    height: 23.31,
    x: 314.19,
    y: 190.57,
    fill: "#d7ecee",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7ecee",
    points: "306.19 192.87 321.43 177.62 336.67 192.87",
    className: "colord7deee svgShape"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.44,
    height: 18.41,
    x: 184.73,
    y: 211.41,
    fill: "#d7ecee",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7ecee",
    points: "178.41 213.22 190.45 201.18 202.48 213.22",
    className: "colord7deee svgShape"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M653.22,610.55H208.85c-10.14,0-18.37-8.22-18.37-18.37V295.55c0-10.14,8.22-18.37,18.37-18.37h444.38 c10.14,0,18.37,8.22,18.37,18.37v296.63C671.59,602.32,663.37,610.55,653.22,610.55z",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 452.34,
    height: 305.73,
    x: 204.86,
    y: 291,
    fill: "#ffffff",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100.72,
    height: 50.01,
    x: 380.68,
    y: 610.55,
    fill: "#d7ecee",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156.74,
    height: 22.65,
    x: 352.66,
    y: 649.73,
    fill: "#d7ecee",
    className: "colord7deee svgShape"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 305.38,
    x2: 558.271,
    y1: 441.072,
    y2: 441.072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68eef9",
    className: "stopColorf9dd68 svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42ebf9",
    className: "stopColorf9a942 svgShape"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 431.83,
    cy: 441.07,
    r: 126.45,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M431.83,554.67c-62.64,0-113.6-50.96-113.6-113.6c0-62.64,50.96-113.6,113.6-113.6 c62.64,0,113.6,50.96,113.6,113.6C545.43,503.71,494.47,554.67,431.83,554.67z M431.83,331.24 c-60.56,0-109.83,49.27-109.83,109.83S371.26,550.9,431.83,550.9s109.83-49.27,109.83-109.83S492.39,331.24,431.83,331.24z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M353.32 471.96v-53.44h-7.85v-12.7h28.93v12.7h-7.85v53.44H353.32zM393.87 472.56c-5.29 0-9.33-1.6-12.12-4.79-2.79-3.19-4.19-7.81-4.19-13.85V422.5c0-5.66 1.38-9.96 4.15-12.89 2.77-2.93 6.82-4.4 12.16-4.4 5.34 0 9.39 1.47 12.16 4.4 2.77 2.93 4.15 7.23 4.15 12.89v31.42c0 6.04-1.4 10.65-4.19 13.85C403.2 470.96 399.16 472.56 393.87 472.56zM393.98 460.38c2 0 3.01-1.94 3.01-5.82v-32.28c0-3.26-.98-4.89-2.93-4.89-2.2 0-3.31 1.67-3.31 5v32.24c0 2.05.25 3.53.75 4.42C392 459.94 392.83 460.38 393.98 460.38zM415.51 471.96v-66.14h13.08v26.49l6.16-26.49h13.3l-7.4 30.29 8.94 35.85h-13.72l-7.22-32.02v32.02H415.51zM451.85 471.96v-66.14h26.45v12.78h-13v12.89h12.48v12.44H465.3v15.14h13.87v12.89H451.85zM483.53 471.96v-66.14h13.6l6.09 31.68v-31.68H516v66.14h-12.93l-6.62-33.07v33.07H483.53z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M405.15 520.87v-37.69h7.75l3.47 18.05v-18.05h7.28v37.69h-7.37l-3.77-18.85v18.85H405.15zM427 520.87v-37.69h15.08v7.35h-7.5v6h7.11v7.26h-7.11v17.09H427zM447.73 520.87v-30.45h-4.48v-7.24h16.49v7.24h-4.48v30.45H447.73z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M436.96,397.57l-16.12-26.6l16.12-26.6l16.12,26.6L436.96,397.57z M422.15,370.97l14.81,24.44 l14.81-24.44l-14.81-24.44L422.15,370.97z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M426.69,397.57l-16.12-26.6l16.12-26.6l16.12,26.6L426.69,397.57z M411.88,370.97l14.81,24.44 l14.81-24.44l-14.81-24.44L411.88,370.97z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M431.83,584.36c-79.01,0-143.29-64.28-143.29-143.29c0-79.01,64.28-143.29,143.29-143.29 s143.29,64.28,143.29,143.29C575.12,520.08,510.84,584.36,431.83,584.36z M431.83,299.76c-77.92,0-141.31,63.39-141.31,141.31 s63.39,141.31,141.31,141.31c77.92,0,141.31-63.39,141.31-141.31S509.75,299.76,431.83,299.76z",
    className: "colord7deee svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M539.72,541.1l-7.07-6.6c41.26-44.16,36.72-94.6,36.67-95.1l9.62-0.99 C579.17,440.64,584.1,493.61,539.72,541.1z",
    className: "colord7deee svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M330.05,348.66l-7.22-6.43c18.9-21.23,40.69-31.56,41.61-31.99l4.1,8.76 C368.33,319.1,347.57,328.98,330.05,348.66z",
    className: "colord7deee svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7ecee",
    points: "291.9 416.07 246.01 416.07 224.37 383.46 226.02 382.36 247.07 414.09 291.9 414.09",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M223.32,385.15c-2.84,0-5.15-2.31-5.15-5.15s2.31-5.15,5.15-5.15c2.84,0,5.15,2.31,5.15,5.15 S226.16,385.15,223.32,385.15z M223.32,376.82c-1.75,0-3.18,1.42-3.18,3.17s1.42,3.17,3.18,3.17c1.75,0,3.17-1.42,3.17-3.17 S225.07,376.82,223.32,376.82z",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7ecee",
    points: "226.02 497.29 224.37 496.19 246.01 463.58 291.9 463.58 291.9 465.56 247.07 465.56",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M223.32,504.8c-2.84,0-5.15-2.31-5.15-5.15c0-2.84,2.31-5.15,5.15-5.15c2.84,0,5.15,2.31,5.15,5.15 C228.47,502.49,226.16,504.8,223.32,504.8z M223.32,496.48c-1.75,0-3.18,1.42-3.18,3.17c0,1.75,1.42,3.17,3.18,3.17 c1.75,0,3.17-1.42,3.17-3.17C226.49,497.9,225.07,496.48,223.32,496.48z",
    className: "colord7deee svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7ecee",
    points: "636.05 497.29 615 465.56 570.17 465.56 570.17 463.58 616.06 463.58 637.7 496.19",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M638.75,504.8c-2.84,0-5.15-2.31-5.15-5.15c0-2.84,2.31-5.15,5.15-5.15s5.15,2.31,5.15,5.15 C643.9,502.49,641.59,504.8,638.75,504.8z M638.75,496.48c-1.75,0-3.17,1.42-3.17,3.17c0,1.75,1.42,3.17,3.17,3.17 s3.17-1.42,3.17-3.17C641.93,497.9,640.5,496.48,638.75,496.48z",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#d7ecee",
    points: "616.06 416.07 570.17 416.07 570.17 414.09 615 414.09 636.05 382.36 637.7 383.46",
    className: "colord7deee svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7ecee",
    d: "M638.75,385.15c-2.84,0-5.15-2.31-5.15-5.15s2.31-5.15,5.15-5.15s5.15,2.31,5.15,5.15 S641.59,385.15,638.75,385.15z M638.75,376.82c-1.75,0-3.17,1.42-3.17,3.17s1.42,3.17,3.17,3.17s3.17-1.42,3.17-3.17 S640.5,376.82,638.75,376.82z",
    className: "colord7deee svgShape"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M592.07,252.68c-3.05-8.23-1.08-6.26-9.31-9.31c8.23-3.05,6.26-1.08,9.31-9.31 c3.05,8.23,1.08,6.26,9.31,9.31C593.15,246.42,595.12,244.45,592.07,252.68z",
    className: "colorffffff svgShape"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M449.17,232.5c-3.05-8.23-1.08-6.26-9.31-9.31c8.23-3.05,6.26-1.08,9.31-9.31 c3.05,8.23,1.08,6.26,9.31,9.31C450.25,226.24,452.22,224.27,449.17,232.5z",
    className: "colorffffff svgShape"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M571.78,264.9c-2.28-6.16-0.81-4.69-6.97-6.97c6.16-2.28,4.69-0.81,6.97-6.97 c2.28,6.16,0.81,4.69,6.97,6.97C572.59,260.22,574.07,258.74,571.78,264.9z",
    className: "colorffffff svgShape"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#355254",
    d: "M691.27,350.82c1.42,0.51,2.93,0.92,4.5,1.25c10.46,2.18,23.53,0.54,31.11-0.8 c3.81-0.68,6.23-1.27,6.23-1.27s1.22-10.9,1.22-15.06c0-2.54-0.18-4.9-0.5-7.09c-2.18-15.01-10.77-21.84-11.37-22.31 c-0.01-0.01-0.02-0.01-0.03-0.02c-0.01,0-0.01-0.01-0.01-0.01H706.3l-5.91,3.23l-1.18,0.65l-0.45,0.25l-6.47,3.54l-0.16,5.91 l-0.12,4.7L691.27,350.82z",
    className: "color433554 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#355254",
    d: "M694.53,348.69c0.3,1.15,0.71,2.31,1.24,3.38c10.46,2.18,23.53,0.54,31.11-0.8 c0.02-0.02,0.03-0.04,0.04-0.06c2.58-4.17,3.74-9.21,3.86-14.2c0.12-4.99-0.75-9.95-1.99-14.76c-0.97-3.78-2.18-7.53-4.23-10.78 c-1.56-2.47-3.64-4.61-6.15-5.96c-0.12-0.07-0.25-0.13-0.37-0.2c-2.77-1.37-5.8-1.43-8.84-1.4c-3.91,0.03-7.9,1.97-10,5.48 c-1.91,3.19-2.09,7.16-2.55,10.9c-0.58,4.75-1.71,9.41-2.4,14.14C693.57,339.17,693.34,344.07,694.53,348.69z",
    className: "color433554 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7df5ff",
    d: "M653.55,401.76c0,0-3.04-5.4-5.48-5.51c-2.45-0.11-6.98-1.59-6.62-0.53c0.36,1.06,3.17,1.17,3.44,1.8 c0.27,0.63-4.17,1.59-5.44,1.69c-1.27,0.11-4.26,0-4.17,0.74c0.09,0.74,5.39,3.81,9.13,3.39c3.74-0.42,8.36,1.27,8.36,1.27 L653.55,401.76z",
    className: "colorffb27d svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52969b",
    d: "M697.45,403.5c0,0-1.65,3.82-4.64,8.21c-3.61,5.28-9.17,11.38-16.15,12.58c-3.34,0.57-6.6-0.26-9.6-1.82 c-0.01,0-0.01,0-0.01,0c-8.48-4.4-14.86-14.52-14.86-14.52c-1.49-4.77,0.95-8,0.95-8s17.13,4.5,18.76,3.55 c1.63-0.95,11.66-26.95,13.47-31.29c3.84-9.21,9.93-11.85,9.93-11.85L697.45,403.5z",
    className: "color9b7052 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52969b",
    d: "M692.81,411.71c-3.61,5.28-9.17,11.38-16.15,12.58c-3.34,0.57-6.6-0.26-9.6-1.82 c0.33,0.05,8.8,1.27,12.18-5.79c3.44-7.2,7.17-18.64,12.28-14.83C693.73,403.51,693.63,407.6,692.81,411.71z",
    className: "color9b7052 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#355254",
    d: "M761.35 619.57c0 0 5.23 5.58 4.21 9.53-1.02 3.96-5.74 6.6-6.37 11.44-.64 4.84-3.19 7.48-5.48 7.48-2.29 0-10.94 0-10.94 0s-1.69-3.41 2.39-4.43c4.08-1.03 5.62-6.72 5.36-11.99-.25-5.28.38-12.32.38-12.32l8.67-2.35L761.35 619.57zM717.11 621.94c0 0 1.88 23.61-.41 24.93l-29.36-.07c0 0 0-3.96 4.72-4.84 4.72-.88 13-4.11 14.4-11.29C707.86 623.48 717.11 621.94 717.11 621.94z",
    className: "color433554 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21787f",
    d: "M739.7,387.58c0,0,0.44,7.21,0,15.86c-0.29,5.73-5.25,13.42-5.96,15.32c-1.77,4.77-3.76,5.54-3.76,5.54 l-15.42,4.42l-5.42,1.55l-17.09-5.97c0,0-7.79-25.4-4.66-39.7c3.13-14.3,7.9-24.23,7.9-24.23s11.59-5.35,32.11-1.35 L739.7,387.58z",
    className: "color7f4721 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aaedf2",
    d: "M735.19,405.78c-0.29,5.74-0.74,11.08-1.45,12.98c-1.77,4.77-3.76,5.54-3.76,5.54l-15.42,4.42l-6.7-2.3 c0,0,22.35-3.96,19.88-26.43L735.19,405.78z",
    className: "colorf2ccaa svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192a2b",
    d: "M693.14,428.15c0,0-8.47,30.8-9.01,41.28c-0.54,10.48,16.18,148.95,16.85,153.78 c0.63,4.55,5.47,7.46,5.47,7.46s2.23,1.53,5.4,0.49c4.41-1.45,5.8-3.2,5.8-3.2s6.59-98.75,2.51-134.03 c-4.08-35.28-4.13-65.78-4.13-65.78H693.14z",
    className: "color2b2419 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334243",
    d: "M729,427.23c0,0,12.91,20.25,14.12,33.94c1.2,13.69,1.89,61.77,4.45,75.12 c2.56,13.34,11.99,39.03,11.99,80.65c0,0-0.98,2.39-4,3.66c-0.97,0.41-2.26,0.8-3.52,1.14c-2.49,0.67-5.05-0.76-6.19-3.43 c-6.37-14.99-26.66-63.34-27.7-73.38c-0.74-7.1-7.14-54.11-21.12-81.69c-3.36-6.62,2.06-32.96,2.06-32.96L729,427.23z",
    className: "color433c33 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6ba5aa",
    d: "M691.79,423.4c0,0,3.4,3.14,10.15,3.3c8.06,0.19,28.05-2.4,28.05-2.4s0.89,2.9,0.85,5.96 c0,0-24.4,7.2-38.55,1.05C692.29,431.31,690.46,427.3,691.79,423.4z",
    className: "coloraa846b svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21787f",
    d: "M700,426.51c-1.36,0-2.46,1.54-2.46,3.44c0,1.9,1.1,3.44,2.46,3.44c1.36,0,2.46-1.54,2.46-3.44 C702.46,428.05,701.36,426.51,700,426.51z",
    className: "color7f4721 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cee1e3",
    d: "M753.66,431.61l-19.82,20.17c-1.43,1.46-3.6,1.28-4.85-0.39l-25.29-33.94c-1.25-1.67-1.1-4.21,0.34-5.67 l19.82-20.17c1.43-1.46,3.6-1.28,4.85,0.39L754,425.94C755.24,427.61,755.09,430.15,753.66,431.61z",
    className: "colore3d6ce svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7df5ff",
    d: "M724.34,429.06c-0.28,0.09-10.53,1.49-10.53,3.97c0,2.86,3,6.69,5.83,6.51c1.15-0.07,6.43-5.75,6.43-5.75 L724.34,429.06z",
    className: "colorffb27d svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M719.08,357.71c-1.17-3.3-1.85-8.34-1.83-14.56l-0.77,0.18l-13.01,3.01c0,0,0.3,4.79,0.31,9.3 c0,0.04,0,0.08,0,0.11c0.02,3.92-2.26,7.85,3.11,9.4C708.54,365.62,721.53,364.65,719.08,357.71z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85d4da",
    d: "M703.47,346.33c0,0,0.3,4.79,0.31,9.3c7.28-0.24,11.13-8,12.71-12.31L703.47,346.33z",
    className: "colordaad85 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M693.35,330.29c0.24,1.19,0.56,2.43,0.94,3.73c0,0-0.54,6.41,0.09,7.85c0.64,1.44,4.7,10.4,8.96,9.84 c3.56-0.46,12.26-6,15.29-9.3c0.61-0.66,0.98-1.22,1.05-1.65c0.41-2.54,1.84-13.77,1.98-14.71c0.36-2.55,1.37-21.82-20.56-16.46 c-3.95,0.97-7.07,4.22-7.96,8.42C692.5,321.05,692.29,325.12,693.35,330.29z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M718.71,340.44c2.75-0.23,4.76-1.97,5.83-3.42c0.09-0.15,0.17-0.29,0.24-0.42 c0.79-1.52,1.01-6.77-1.01-7.99c-1.15-0.69-2.05-0.01-2.6,0.71v0c-0.21,0.35-0.32,0.62-0.32,0.62L718.71,340.44z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#355254",
    d: "M691.67,319.27c0.03,2.05,0.22,3.72,0.32,4.51c0.04,0.33,0.07,0.51,0.07,0.51 c7.05-5.27,7.08-11.33,6.88-13.24c1.91,10.62,23.09,16.72,23.09,16.72l2.97,1.38c0,0,0.85-0.92,1.6-2.77 c1.21-2.96,2.18-8.29-0.92-16.05c-0.81-2.03-1.93-3.6-3.23-4.81c-0.01-0.01-0.02-0.01-0.03-0.02 c-6.82-6.25-18.72-2.64-18.72-2.64C693.02,301.83,691.57,312.62,691.67,319.27z",
    className: "color433554 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#355254",
    d: "M716.41 332.94c.08-.25.2-.61.37-1.05.18-.44.41-.95.74-1.49.33-.54.75-1.11 1.31-1.59.56-.49 1.18-.82 1.75-1.04.57-.22 1.1-.34 1.55-.41.19-.03.37-.05.53-.07.21-.16.34-.25.34-.25s-.05.08-.13.23c.12-.01.23-.02.32-.02.25-.01.39-.01.39-.01s-.37.19-.97.5c-.15.28-.35.62-.57 1.03-.58 1.05-1.35 2.48-1.81 4.12-.47 1.64-.63 3.29-.77 4.51-.07.61-.13 1.11-.17 1.45-.05.35-.08.54-.08.54s-.05-.19-.14-.52c-.09-.34-.2-.83-.31-1.44-.11-.62-.21-1.36-.22-2.21-.01-.84.06-1.8.35-2.76.28-.97.73-1.81 1.2-2.5.45-.65.92-1.16 1.34-1.58-.61.34-1.28.77-1.9 1.31-.95.82-1.7 1.8-2.27 2.5-.29.35-.52.64-.68.84-.17.2-.26.31-.26.31S716.33 333.19 716.41 332.94zM691.67 319.27c.15-.05.3-.12.45-.19 3.35-1.62 5.52-6.32 6.63-9.45.61-1.71.91-2.94.91-2.94.03.58.3 1.29.73 2.05 2.17 3.86 8.48 9.32 8.48 9.32l-.94-3.07c0 0 1.72 2.99 8.25 7.36 2.66 1.78 6.64 3.1 10.43 4.04 2.68.67 5.27 1.14 7.22 1.46-.41-2.8-1.03-5.31-1.79-7.56-3.31-9.78-9.09-14.37-9.58-14.75-.01-.01-.02-.01-.03-.02-6.82-6.25-18.72-2.64-18.72-2.64-.76-.07-1.47-.09-2.14-.05C692.82 303.34 691.57 313.09 691.67 319.27z",
    className: "color433554 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7df5ff",
    d: "M724.34,429.06c0,0-2.46-0.92-4.1-0.65c-1.64,0.27-2.85-0.04-2.85,0.5c0,0.54,2.12,0.79,2.57,1.05 C720.41,430.21,724.34,429.06,724.34,429.06z",
    className: "colorffb27d svgShape"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#52969b",
    d: "M727.4,359.02c0,0,12.23,1,16.92,14.32c4.69,13.32,13.58,35.69,13.58,39.45c0,3.76-4.97,15.36-31.66,22.03 c0,0-2.76-3.39-2.59-6.08c0,0,16.66-16.72,16.61-18.68c-0.09-3.7-2.73-8.58-17.36-25.68 C718.94,379.74,727.4,359.02,727.4,359.02z",
    className: "color9b7052 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M157.69 344.72c0 0 25.82 41.16 20.12 57.79-6.59 19.22-20.12 11.44-20.12 11.44V344.72zM170.41 647.28h-34.25c-2.45-1.91.66-20.57.66-20.57s9.35-4.07 10.96 4.2c1.62 8.27 11.91 10.89 17.35 11.9C168.86 643.51 170.04 645.86 170.41 647.28zM119.61 647.28H85.36c-2.45-1.91.66-20.57.66-20.57s9.35-4.07 10.96 4.2c1.62 8.27 11.91 10.89 17.35 11.9C118.06 643.51 119.24 645.86 119.61 647.28z",
    className: "color104584 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#192a2b",
    d: "M157.84,505.44c-2.46,35.97-9.09,125.14-9.09,125.14s-4.35,4.25-13.98,1.93c0,0-8.2-30.76-10.65-65.87 c-0.04-0.58-0.08-1.16-0.11-1.73c-2.28-35.74-5.83-111.01-5.83-111.01l43.01-8.67",
    className: "color2b2419 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#334243",
    d: "M151.89,449.33c0,0-24.46,69.82-32.28,96.28c-5.57,18.85-21.28,84.98-21.28,84.98s-6.83,2.38-12.57-2.22 c0,0-5.84-67.56,5.96-86.62c6.26-10.11,1.56-105.07,26.95-105.88C144.06,435.06,151.89,449.33,151.89,449.33z",
    className: "color433c33 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M140.96,346.4c-3.73,2.26-7.38,2.4-10.54,1.63c-2.89-0.7-5.37-2.16-7.14-3.45 c-1.81-1.33-2.88-2.49-2.88-2.49s0.13-0.21,0.34-0.62c1.1-2.16,4.45-9.94,2.96-22.44c-0.02-0.16,1.06,0.07,2.69,0.51 c4.85,1.32,14.61,4.49,15.04,4.63c0.01,0,0.02,0,0.02,0s0.12,2.63,0.52,7.34c0.03,0.42,0.07,0.85,0.11,1.3 c0.05,0.55,0.1,1.14,0.16,1.74C142.7,339.45,140.96,346.4,140.96,346.4z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85d4da",
    d: "M141.98,331.51c-7.25,1.9-18.06-10.36-18.06-10.36c0.79-0.67,1.62-1.21,2.48-1.61 c4.85,1.32,14.61,4.49,15.04,4.63c0.01,0,0.02,0,0.02,0S141.58,326.8,141.98,331.51z",
    className: "colordaad85 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M165.02,437.57c-0.53,8-2,13.73-5.23,13.73c0,0-14.37,5.8-31.54,5.96c-3.36,0.03-8.11-0.72-12.05-1.48 c-4.03-0.78-7.22-1.57-7.22-1.57c-3.45-0.91-7.26-3.36-6.75-7.88c0.27-2.41,0.47-5.49,0.6-9.06c0.01-0.23,0.02-0.46,0.03-0.69 c0.38-10.46,0.32-24.87,0.36-38.67c0.03-8.47,0.11-16.71,0.35-23.66c0,0-3.39-27.29,0.37-31.77c4.41-5.24,18.66-6.77,18.91-6.82 c0,0,11.26,6.98,19.46,1.71c0,0,11.95,3.19,15.39,7.36c1.19,1.43,5.92,10.24,6.05,19.92c0.13,9.7-0.07,20.34-0.2,25.56 c-0.06,2.36,0,4.72,0.16,7.07c0.09,1.36,0.2,2.85,0.31,4.42c0.24,3.44,0.51,7.32,0.73,11.36c0.11,2.04,0.21,4.12,0.3,6.2 C165.3,425.69,165.38,432.15,165.02,437.57z",
    className: "color104584 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#85d4da",
    d: "M163.5,409.16c-0.39-1.7-1.44-3.11-2.83-3.85c-1.77-0.94-4.29-2.21-5.44-2.44 c-1.87-0.39-5.69-2.97-6-1.63c-0.31,1.34,2.7,2.89,2.71,4.36c0.02,1.48-8.45,5.09-8.22,6.62c0.23,1.53,2.64,4.95,5.92,4.04 c3.28-0.91,11.42-3.1,13.3-3.71C163.94,412.23,163.84,410.64,163.5,409.16z",
    className: "colordaad85 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M156.95,413.08c-0.46,0.86-2.67,3.84-4.2,4.14c-3.51,0.71-14.05,3.25-14.05,3.25s-0.89-7.63,0.85-8.2 c1.75-0.58,4.01-5.01,5.16-5.79c0.87-0.59,4.42-1.85,6.69-2.07c0.31,0.4,0.53,0.8,0.53,1.19c0,0.38-0.55,0.9-1.38,1.49 c-0.43,0.27-0.82,0.53-1.11,0.75c-0.34,0.26-0.53,0.47-0.45,0.59c0.42,0.58,1.84,0.37,3.44-0.19c1.6-0.55,5.22-3.1,6.28-1.57 C159.32,407.54,159.12,409,156.95,413.08z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M117.52,380.12c0,0-0.2,25.96,22.03,32.15c0,0-28.93,1.71-29.65,1.3c-0.72-0.41-5.57-12.2-5.57-12.2 L117.52,380.12z",
    className: "color104584 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M104.59 341.79c0 0-7.07 5.56-10.32 23.34-3.25 17.77-1.74 52.59 2.52 56.9 4.26 4.32 24.82 8.22 45.34-2.17 0 0-.96-5.82-2.57-7.6 0 0-23.3-6.32-23.42-10.45-.16-5.56 2.55-21.28 1.09-30.11C115.76 362.88 104.59 341.79 104.59 341.79zM161.1 401.81c0 0 1.04-5.01 1.71-6.89 2.07-5.83-6.31-28.94-5.24-28.26 1.08.69 11 24.17 10.59 26.23C167.75 394.96 164.42 396.46 161.1 401.81z",
    className: "color104584 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M141.4,307.02c0.07,2.86,2.05,5.12,4.41,5.05c2.36-0.07,4.67-2.51,4.6-5.38 c-0.07-2.86-2.05-5.12-4.41-5.05C143.63,301.72,141.32,304.16,141.4,307.02z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M135.83,328.31L135.83,328.31c7.12-0.8,12.44-8.27,12.06-15.35l-0.86-14.8 c-0.47-8.87-7.36-15.73-14.69-15.5l0,0c-7.5,0.23-16.05,8.11-15.81,17.2l2.83,11.24C120.06,321.47,127.25,328.57,135.83,328.31z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#355254",
    d: "M121.4,311.78l1.37-4.59c1-4.1-1.04-7.06-1.77-8.54c-0.84-1.7-0.96-4.49,1.48-7.04 c3.59-3.74,11.25-6.97,18.43-4.39c2.03,0.73,3.59,2.37,4.58,4.57c0.44,0.98,1.16,3,1.25,3.99l-0.38-3.19 c-0.74-8.37-7.8-13.78-14.92-12.85c-2.49,0.32-5.37,0.31-8.48,1.3c-7.87,2.48-12.64,11.88-9.55,20.74l2.96,5.84L121.4,311.78z",
    className: "color433554 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#98f2f9",
    d: "M113.39,310.69c0.07,2.83,2.49,5.01,4.82,4.94c2.34-0.07,4.17-2.43,4.1-5.26 c-0.07-2.83-2.94-4.95-5.28-4.88C114.69,305.57,113.32,307.86,113.39,310.69z",
    className: "colorf9c698 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#355254",
    d: "M122.48,291.61c0,0,2.36-2.29,7.34-0.82c9.64,2.85,14.48-0.17,13.11-4.21l-9.55-2.38l-10.63,2.73 L122.48,291.61z",
    className: "color433554 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNftToken);
export default __webpack_public_path__ + "static/media/nft-token.9fb91f8649a4da81223d45c5eec25f6c.svg";
export { ForwardRef as ReactComponent };